import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { LocalizationHelperInstance } from "utils/helpers";
import { useSalaryDeviationsService } from "serviceHooks";

function useSalarySpecificationActions() {
  const salaryDeviationsService = useSalaryDeviationsService();

  const downloadSalarySpec = async () => {
    salaryDeviationsService.generateSalarySpecification();
  };

  const generateSalarySpecMoreAction: MoreActionMenuItemType = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.DownloadSpecification),
    icon: IconDefinitionConstants.WDownload,
    onClickHandler: downloadSalarySpec,
  };

  return { generateSalarySpecMoreAction };
}

export default useSalarySpecificationActions;
